export default {
	todo: {
		"No project": "No project",
		"Search project": "Search project",
		"Add project": "Add project",
		"Rename project": "Rename project",
		"Delete project": "Delete project",

		"Completed tasks": "Completed tasks",
		Show: "Show",
		Hide: "Hide",
		"Sort by": "Sort by",
		"Text (a-z)": "Text (a-z)",
		"Text (z-a)": "Text (z-a)",
		"Due date (new to old)": "Due date (new to old)",
		"Due date (old to new)": "Due date (old to new)",
		"Completion date (new to old)": "Completion date (new to old)",
		"Completion date (old to new)": "Completion date (old to new)",
		"Created (new to old)": "Created (new to old)",
		"Created (old to new)": "Created (old to new)",
		"Edited (new to old)": "Edited (new to old)",
		"Edited (old to new)": "Edited (old to new)",
		"Priority (high to low)": "Priority (high to low)",
		"Priority (low to high)": "Priority (low to high)",

		"Add task below": "Add task below",
		"Add subtask": "Add subtask",
		"Set due date": "Set due date",
		"Set priority": "Set priority",
		"Reset priority": "Reset priority",
		Indent: "Indent",
		Unindent: "Unindent",
		"Assign to": "Assign to",
		"Move to": "Move to",
		Duplicate: "Duplicate",
		Copy: "Copy",
		Paste: "Paste",
		Delete: "Delete",

		Enter: "Enter",
		Tab: "Tab",
		"Shift+Tab": "Shift+Tab",
		"Ctrl+D": "Ctrl+D",
		"Ctrl+C": "Ctrl+C",
		"Ctrl+V": "Ctrl+V",
		"CMD+D": "CMD+D",
		"CMD+C": "CMD+C",
		"CMD+V": "CMD+V",

		"Type what you want": "Type what you want",
		Search: "Search",
		"Add task": "Add task",
		"New project": "New project",

		High: "High",
		Medium: "Medium",
		Low: "Low",
	},
};
